var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatText = function SvgChatText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M4.017 17.84a1.5 1.5 0 0 1 .43 1.203 16.5 16.5 0 0 1-.597 2.999c2.092-.484 3.37-1.045 3.951-1.34a1.5 1.5 0 0 1 1.067-.11c.986.265 2.038.408 3.132.408 5.993 0 10.5-4.211 10.5-9S17.993 3 12 3 1.5 7.211 1.5 12c0 2.202.926 4.246 2.517 5.84m-.74 5.858-.451.087q-.301.054-.618.107c-.299.049-.527-.264-.41-.542a15 15 0 0 0 .366-.956l.006-.017c.371-1.08.674-2.32.785-3.477C1.115 17.055 0 14.641 0 12 0 6.201 5.373 1.5 12 1.5S24 6.201 24 12s-5.373 10.5-12 10.5c-1.225 0-2.407-.16-3.52-.46-.78.396-2.458 1.114-5.203 1.658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M6 8.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 8.25M6 12a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12m0 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75"
  })));
};
export default SvgChatText;